import moment from "moment";

export const datetime = (value) => {
	if (!value) return ''
	return moment(String(value)).format('MM/DD/YYYY h:mma');
};
